import { useRef } from "react"
import styles from "./Footer.module.css"

function Footer() {

    const privacyDialog = useRef(null)
    const termsDialog = useRef(null)
    const manageDialog = useRef(null)

    const openDialog = (ref) => {
        if (ref.current) ref.current.showModal()
    }

    const closeDialog = (ref) => {
        if (ref.current) ref.current.close()
    }

    return(
        <footer className={styles.footer}>
        <header>
            
            <div className={styles.interaction}>
                <span></span>

                <div className={styles.title}>
                    <p onClick={() => openDialog(privacyDialog)}>Privace Policy</p>
                    <dialog ref={privacyDialog}>
                        <h2>Privace Policy</h2>
                        <p> 
                            This website collects and processes personal data in accordance with applicable privacy and data protection regulations. Information such as name, email, and interactions with the site may be stored to enhance your experience and provide our services. To learn more about how we use your data and your rights, please refer to our Privacy Policy.
                        </p>
                        <button onClick={() => closeDialog(privacyDialog)}> Ok </button>           
                    </dialog>

                    <p onClick={() => openDialog(termsDialog)} >Terms of use</p>
                    <dialog ref={termsDialog}>
                        <h2>Terms Of Use</h2>
                        <p>
                            By accessing this website, you agree to comply with our terms and conditions of use. The content available is protected by copyright and may not be reproduced without authorization. Using the website for illegal or harmful purposes is strictly prohibited. For more details on the rules of use, please refer to our Terms of Use.
                        </p>                
                        <button onClick={() => closeDialog(termsDialog)}> Ok </button>          
                    </dialog>

                    <p onClick={() => openDialog(manageDialog)}  > Manage Cookies</p>
                    <dialog ref={manageDialog}>
                        <h2>Manage Cookies</h2>
                        <p>
                            We use cookies to enhance your browsing experience and personalize the displayed content. You can manage your cookie preferences at any time by adjusting your settings. To learn more about how we use cookies and how to configure them, please visit our Cookie Policy.             
                        </p>
                        <button onClick={() => closeDialog(manageDialog)}> Ok </button> 
                    </dialog>
                </div>

                <div className={styles.iconDeve}>
                    <a href="https://www.linkedin.com/company/engiforge-pesquisa-e-desenvolvimento/">
                        <ion-icon name="logo-linkedin"></ion-icon>
                    </a>
                    <a href="#">
                        <ion-icon name="logo-discord"></ion-icon>
                    </a>
                    <a href="#">
                        <ion-icon name="logo-twitter"></ion-icon>
                    </a>
                    <a href="#">
                        <ion-icon name="logo-medium"></ion-icon>
                    </a>
                </div>
            </div>

            <p className={styles.videoCredit}> Stock Video by
                <a href="https://www.vecteezy.com/free-videos/hackers" target="_blank" rel="noopener noreferrer">  Vecteezy </a>
            </p>

            <p className={styles.copyright}>Copyright © 2025 Engiforge Ltd. Created & Registered with ♥</p>
        </header>
        </footer> 
    )
}

export default Footer
